
export const RoutesPanelist = [

    /**
     * -----------------------------------------------
     * Landing page routes
     * -----------------------------------------------
     */

    {
        // To survey
        path: '/p/entry',
        component: () => import('@/modules/PanelistProjectEntry/components/index.vue'),
    },
    {
        // To hosted fake survey
        path: '/p/survey',
        component: () => import('@/modules/PanelistProjectEntry/components/TestSurvey.vue'),
    },
    {
        // From survey
        path: '/p/exit',
        component: () => import('@/modules/PanelistProjectExit/components/index.vue'),
    },
    {
        path: '/p/email/confirm',
        component: () => import('@/modules/PanelistProjectExit/components/ConfirmEmail.vue'),
    },
    {
        path: '/privacy-policy/:subPanelId/:locale',
        component: () => import('@/modules/Policies/components/index.vue'),
    },
    {
        path: '/terms-of-use/:subPanelId/:locale',
        component: () => import('@/modules/Policies/components/index.vue'),
    },
    {
        path: '/cookie-policy/:subPanelId/:locale',
        component: () => import('@/modules/Policies/components/index.vue'),
    },
    {
        path: '/registration/:subPanelId/:locale?',
        component: () => import('@/modules/RegistrationSurvey/components/index.vue'),
    },
    {
        path: '/co-registration/:partnerName/:subPanelId/:locale/:uuid',
        component: () => import('@/modules/PanelistLandingPage/components/index.vue'),
    },
    {
        path: '/landing-page/locale-error',
        component: () => import('@/modules/PanelistLandingPage/components/index.vue'),
    },
    {
        path: '/p/unsubscribe/:panelistId/:subPanelId/:locale/:projectId?',
        component: () => import('@/modules/Unsubscribe/components/index.vue'),
    },
    {
        path: '/p/unsubscribe-confirmed/:panelistId/:subPanelId/:locale/:projectId?',
        component: () => import('@/modules/Unsubscribe/components/index.vue'),
    },
    {
        path: '/p/password-reset',
        component: () => import('@/modules/PanelistResetPassword/components/index.vue'),
    },
    {
        path: '/community/refer-friend/token/:token',
        component: () => import('@/modules/PanelistLandingPage/components/index.vue'),
    },
    {
        path: '/p/password-create',
        component: () => import('@/modules/PanelistCreatePassword/components/index.vue'),
    },
    {
        path: '/landing-page/:name/:subPanelId/:locale',
        component: () => import('@/modules/PanelistLandingPage/components/index.vue'),
    },
    {
        path: '/mobile-app/:subPanelId/:locale',
        component: () => import('@/modules/MobileAppDownload/components/index.vue'),
    },

    /**
     * --------------------------------------------------------
     *  Member's App routes
     * --------------------------------------------------------
     */

    {
        path: '/app/login/:subPanelId/:locale?',
        component: () => import('@/modules/MemberApp/components/AppLogin.vue'),
    },
    {
        path: '/app/surveys', name: 'app-surveys',
        component: () => import('@/modules/MemberApp/components/AppSurveys.vue'),
    },
    {
        path: '/app/profile', name: 'profile',
        component: () => import('@/modules/MemberApp/components/AppProfile.vue'),
    },
    {
        path: '/app/account', name: 'app-account',
        component: () => import('@/modules/MemberApp/components/AppAccount.vue'),
    },
    {
        path: '/app/rewards', name: 'app-rewards',
        component: () => import('@/modules/MemberApp/components/AppRewards.vue'),
    },
    {
        path: '/app/redemptions', name: 'app-redemptions',
        component: () => import('@/modules/MemberApp/components/AppRedemptions.vue'),
    },
    {
        path: '/app/refer-friend', name: 'app-refer-friend',
        component: () => import('@/modules/MemberApp/components/AppReferAFriend.vue'),
    },
    {
        path: '/app/data',
        component: () => import('@/modules/MemberApp/components/AppCollectedData.vue'),
    },
    {
        path: '/app/activity', name: 'app-activity',
        component: () => import('@/modules/MemberApp/components/AppActivityHistory.vue'),
    },
    {
        path: '/app/close-account',
        component: () => import('@/modules/MemberApp/components/AppCloseAccount.vue'),
    },
    {
        path: '/supplier/:identifier',
        component: () => import('@/modules/PanelistProjectEntry/components/index.vue'),
    }
];